import users from './users/index'
import roles from './roles/index'
import nsi from './nsi/index'
import organizations from './organizations/index'

export default {
  namespaced: true,
  modules: {
    users,
    roles,
    nsi,
    organizations
  }
}